import React from 'react';

function BlockMN() {
  return (
    <>
      <style>
        {`
          .block-mn-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .official-use-badge {
            background-color: #f44336;
            color: white;
            text-align: center;
            padding: 8px;
            font-weight: bold;
            font-size: 14px;
            margin-bottom: 20px;
            border-radius: 4px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .form-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
          }
          .form-row {
            display: flex;
            gap: 30px;
            margin-bottom: 15px;
          }
          .form-column {
            flex: 1;
          }
          .form-group {
            margin-bottom: 15px;
          }
          .form-label {
            font-weight: 600;
            color: #333;
            margin-bottom: 5px;
            display: block;
            font-size: 14px;
          }
          .form-input {
            width: 100%;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            background-color: #fff;
          }
          .comments-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 20px;
          }
          .comments-title {
            font-weight: 600;
            color: #1976d2;
            margin-bottom: 10px;
            font-size: 16px;
          }
          .comments-instructions {
            background-color: #f8f9fa;
            padding: 15px;
            border-radius: 4px;
            margin-bottom: 15px;
            font-size: 12px;
            color: #666;
            line-height: 1.5;
            border-left: 4px solid #1976d2;
          }
          .comments-textarea {
            width: 100%;
            min-height: 200px;
            padding: 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            resize: vertical;
            background-color: #fff;
          }
          @media (max-width: 768px) {
            .form-row {
              flex-direction: column;
              gap: 15px;
            }
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Official Use Badge */}
        <div className="official-use-badge">
          FOR OFFICIAL USE ONLY
        </div>

        {/* Header Section */}
        <div className="block-mn-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">M. Particulars of Field Operations</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
            </div>
          </div>
        </div>

        {/* Officer Details and Dates Section */}
        <div className="form-section">
          <div className="form-row">
            {/* Left Column - Officer Details */}
            <div className="form-column">
              <div className="form-group">
                <label className="form-label">1. Name of S.S.O.</label>
                <input type="text" className="form-input" placeholder="Enter S.S.O. name" />
              </div>
              <div className="form-group">
                <label className="form-label">2. Signature of S.S.O.</label>
                <input type="text" className="form-input" placeholder="Enter signature" />
              </div>
              <div className="form-group">
                <label className="form-label">3. Name and Designation of Scrutinising officer</label>
                <input type="text" className="form-input" placeholder="Enter name and designation" />
              </div>
              <div className="form-group">
                <label className="form-label">4. Signature of Scrutinising officer</label>
                <input type="text" className="form-input" placeholder="Enter signature" />
              </div>
            </div>

            {/* Right Column - Dates */}
            <div className="form-column">
              <div className="form-group">
                <label className="form-label">5. Date of Receipt from Factory</label>
                <input type="date" className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label">6. Date of Verification/Compilation</label>
                <input type="date" className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label">7. Date of Submission by S.S.O.</label>
                <input type="date" className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label">8. Date (s) of Scrutiny</label>
                <input type="date" className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label">9. Date of Despatch</label>
                <input type="date" className="form-input" />
              </div>
            </div>
          </div>
        </div>

        {/* Comments Section */}
        <div className="comments-section">
          <div className="comments-title">N. COMMENTS of Supdt./Sr.Supdt./Scrutinsing officer</div>
          <div className="comments-instructions">
            (Please note that reasons for abnormal values or entries (high or low)in respect of important characteristics (such as GVA, working capital, wage rate, number of workers, distributive expenses, depreciation etc.) should be given invariably, for instance reason for high GVA could be increase demand/production, profit, govt. subsidy; or for low GVA, the reasons could be decreased demand/production, capacity under/utilisation, high input cost etc. Similarly, reasons for abnormal values of certain important ratios e.g. ratio of output to input, ratio of depreciation/distributive expenses to output etc. should be given. Please refer to detailed instructions also for further guidance.)
          </div>
          <textarea 
            className="comments-textarea" 
            placeholder="Enter comments here..."
          ></textarea>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockMN; 